<template lang="pug">

	header(ref="header")
		.header-inner(v-if="nav")
			a.logo.desktop-logo(href='/')
				include ../../../pug/partials/logo-white.pug
			a.logo.mobile-logo(href='/')
				include ../../../pug/partials/logo-c-white.pug

			.mobile-nav
				.mobile-search-trigger
					i.fal.fa-search(@click="toggleSearch(true)")
				.mobile-nav-trigger(@click="mobileNav = !mobileNav")
					i.fal.fa-bars(v-if="!mobileNav")
					i.fal.fa-times(v-else)

				nav(:class="{ 'active' : mobileNav }" ref="mobileNav")
					template(v-for="(link, index) in nav")
						template(v-if="link.page && link.page.url === null")
							a.top-level(
								:class="{ 'active' : checkCurrentLink(link.page.slug) }"
								@click="nav[index].active = !nav[index].active"
							)
								span {{ link.page.title }}
								i.fal.pl-2(:class="{ 'fa-chevron-up' : link.active, 'fa-chevron-down' : !link.active }")

							a.sub-level(
								v-if="link.active"
								v-for="(child, index) in link.children"
								:href="child.page.url"
								@click="mobileNav = false"
							) {{ child.page.title }}

						template(v-else)
							a.top-level(
								:class="{ 'active' : checkCurrentLink(link.page.slug) }"
								@click="toggleMegaNav(false); mobileNav = false"
								:href="link.page.url"
							)
								span {{ link.page.title }}

			.desktop-nav
				nav(@mouseover="focus = true" @mouseleave="focus = false" :class="{'focused': focus }" ref="desktopNav")
					template(v-for="(link, index) in nav")
						a(
							v-if="link.page.url === null"
							:class="{ 'active' : checkCurrentLink(link.page.slug) }"
							@click="toggleMegaNav()"
							@mouseover="megaNav.index = index"
						)
							span {{ link.page.title }}
							i.fal.pl-2.text-sm(:class="{ 'fa-chevron-up' : link.active, 'fa-chevron-down' : !link.active }")
						a(
							v-else
							:class="{ 'active' : checkCurrentLink(link.page.slug) }"
							@click="toggleMegaNav(false)"
							:href="link.page.url"
						)
							span {{ link.page.title }}

					a.search-component
						i.fal.fa-search(@click="toggleSearch(true)")

			.mega-nav(:class="{ 'active' : megaNav.active }")
				template(v-if="nav[megaNav.index].children.length > 0")

					template(v-for="(child, index) in nav[megaNav.index].children" :class="child.page.type.value")

						template(v-if="child.page.links_to_sectors.length > 0")
							span.mega-nav-tab(
								:class="{ 'active' : megaNav.activeTab === 'links_to_sectors' }"
								@click="megaNav.activeTab = 'links_to_sectors'"
							) Sectors
						template(v-if="child.page.links_to_services.length > 0")
							span.mega-nav-tab(
								:class="{ 'active' : megaNav.activeTab === 'links_to_services' }"
								@click="megaNav.activeTab = 'links_to_services'"
							) Services

					.nav-group-wrap

						.nav-group
							
							template(v-for="(child, index) in nav[megaNav.index].children" :class="child.page.type.value")

								template(v-if="child.page.links_to_sectors.length > 0")
									template(v-if="megaNav.activeTab === 'links_to_sectors'")
										a.sector-link(
											v-for="(sector, index) in child.page.links_to_sectors"
											:href="sector.url"
											@click="toggleMegaNav(false)"
										)
											span {{ sector.title }}

										a.view-all.btn.btn-white.hollow(
											href="/sectors"
											@click="toggleMegaNav(false)"
										) View all Sectors

								template(v-if="child.page.links_to_services.length > 0")
									template(v-if="megaNav.activeTab === 'links_to_services'")
										a.service-link(
											v-for="(service, index) in child.page.links_to_services"
											:href="service.url"
											@click="toggleMegaNav(false)"
										)
											span {{ service.title }}

										a.view-all.btn.btn-white.hollow(
											href="/services"
											@click="toggleMegaNav(false)"
										) View all Services
								
								a.page-link(
									:class="child.page.type ? child.page.type.value : ''"
									v-if="child.page.url != null"
									:href="child.page.url"
									@click="toggleMegaNav(false)"
								)
									span {{ child.page.title }}

						//- .nav-image(v-if="nav[megaNav.index].page.image != null")
						//- 	img(
						//- 		width="400"
						//- 		:src="'/img/'+nav[megaNav.index].page.image.url+'?w=400'"
						//- 		:alt="nav[megaNav.index].page.image.alt"
						//- 	)
			

			.search-bar(:class="{ 'active' : search.active }")
				.search-input
					input(placeholder="Start typing..." v-model="search.query" @keyup="performSearch()" ref="searchInput")
					i.fal.fa-search
				.search-close(@click="toggleSearch(false)")
					i.fal.fa-times

			.search-results(:class="{ 'active' : search.results.length > 0 }" ref="searchResults")
				.results-count(v-if="totalSearchResults > 0")
					span {{ totalSearchResults }} results found for "{{ search.query }}"...
				.results-count(v-else)
					span No results found for "{{ search.query }}"...
				.results-list
					template(v-for="(result, index) in search.results")
						.search-result-group(v-if="result.hits.length > 0")
							.uppercase.opacity-50 {{ result.index }}
							template(v-for="(hit, index) in result.hits")
								a.search-result-item(
									:href="hit.url"
									@click="toggleSearch(false)"
								)
									span {{ hit.title }}

</template>

<script>
// Aloglia Search
const algoliasearch = require("algoliasearch");
const client = algoliasearch("GY01NN8YBN", "f95a5f0656e83a3bca66728151aa1cf1");

const axios = require("axios");
import NavQuery from "../graphql/nav.graphql";
import { print } from "graphql/language/printer";
let NavQueryString = print(NavQuery);

export default {
	el: "site-header",
	name: "Header",
	data() {
		return {
			nav: false,
			mobileNav: false,
			focus: false,
			currentUrl: "",
			megaNav: {
				active: false,
				index: 0,
				activeTab: "links_to_sectors",
			},
			search: {
				active: false,
				query: "",
				results: [],
			},
		};
	},
	methods: {
		getNav() {
			return axios({
				url: "/graphql",
				method: "post",
				data: {
					query: NavQueryString,
				},
			});
		},
		checkCurrentLink() {},
		toggleMegaNav(force = null) {
			console.log("toggleMegaNav", force);
			if (force !== null) {
				this.megaNav.active = force;
				if (force === false) {
					console.log("force false");
					window.dispatchEvent(new CustomEvent("hideoverlay"));
				} else {
					window.dispatchEvent(new CustomEvent("showoverlay"));
				}
			} else {
				this.megaNav.active = !this.megaNav.active;
				window.dispatchEvent(new CustomEvent("toggleoverlay"));
			}
		},
		toggleSearch(force = null) {
			if (force !== null) {
				this.search.active = force;
				if (force === false) {
					window.dispatchEvent(new CustomEvent("hideoverlay"));
				} else {
					window.dispatchEvent(new CustomEvent("showoverlay"));
				}
			} else {
				this.search.active = !this.search.active;
				window.dispatchEvent(new CustomEvent("toggleoverlay"));
			}
			this.megaNav.active = false;

			if (this.search.active) {
				this.$refs.searchInput.focus();
				this.mobileNav = false;
			} else {
				this.search.results = [];
				this.search.query = "";
			}
		},
		performSearch() {
			if (this.search.query.length < 3) {
				this.search.results = [];
				return; // only run if more than 3 characters
			}

			const queries = [
				{
					indexName: "people",
					query: this.search.query,
					params: {
						hitsPerPage: 6,
					},
				},
				{
					indexName: "pages",
					query: this.search.query,
					params: {
						hitsPerPage: 6,
					},
				},
				{
					indexName: "digital_solutions",
					query: this.search.query,
					params: {
						hitsPerPage: 6,
					},
				},
				{
					indexName: "testimonials",
					query: this.search.query,
					params: {
						hitsPerPage: 6,
					},
				},
				{
					indexName: "case_studies",
					query: this.search.query,
					params: {
						hitsPerPage: 6,
					},
				},
				{
					indexName: "news",
					query: this.search.query,
					params: {
						hitsPerPage: 6,
					},
				},
				{
					indexName: "awards",
					query: this.search.query,
					params: {
						hitsPerPage: 6,
					},
				},
				{
					indexName: "sectors",
					query: this.search.query,
					params: {
						hitsPerPage: 6,
					},
				},
				{
					indexName: "services",
					query: this.search.query,
					params: {
						hitsPerPage: 6,
					},
				},
			];

			let r = [];

			client.multipleQueries(queries).then(({ results }) => {
				results.forEach((result) => {
					let res = {};
					res.index = result.index.replace("_", " ");
					res.hits = result.hits;
					r.push(res);
				});
			});

			this.search.results = r;
		},
	},
	computed: {
		totalSearchResults() {
			return this.search.results.reduce((acc, result) => {
				return acc + result.hits.length;
			}, 0);
		},
	},
	watch: {
		mobileNav: {
			handler() {
				// if mobileNav is active, make nav height 100vh
				if (this.mobileNav) {
					let fullHeight = window.innerHeight;
					let headerHeight = this.$refs.header.clientHeight;
					let diff = fullHeight - headerHeight + "px";
					this.$refs.mobileNav.style.height = diff;
					this.$refs.searchResults.style.height = diff;
					document.body.classList.add("overflow-hidden");
				} else {
					document.body.classList.remove("overflow-hidden");
				}
			},
		},
	},
	mounted() {
		this.getNav().then((response) => {
			// this.nav = response.data.data.nav.tree;
			let nav = [];
			response.data.data.nav.tree.forEach((item) => {
				let navItem = {};
				navItem.active = false;
				navItem.children = item.children.length ? item.children : null;
				navItem.page = item.page ? item.page : null;
				nav.push(navItem);
			});
			this.nav = nav;
		});

		window.addEventListener("page-change", () => {
			this.currentUrl = window.currentURL;
		});

		window.addEventListener("overlayclosed", () => {
			this.megaNav.active = false;
			this.search.active = false;
			this.search.results = [];
			this.search.query = "";
		});
	},
};
</script>
